import React from "react";
import {useDispatch, useSelector} from "react-redux";
import profileImagePlaceholder from "../../../assets/profile-placeholder.png"
import EditIcon from "@material-ui/icons/Edit";
import {EditStudentInfo} from "../../CommonComponents";
import {openDialog} from "../../../slices/dialog";
import ButtonCircle from "../../Common/ButtonCircle";
import {getAgeFromBirthday} from "../../../helpers/misc";
import {professionScopes} from "../../../db/datasets/professions";
import "./Info.scss";
import {useTranslation} from "react-i18next";
import {selectRole} from "../../../slices/profile";

interface Props {
    student: any
}

const StudentInfo: React.FC<Props> = ({student}) => {
    const {t} = useTranslation();
    const name = student?.name?.split("_")[0] || "";
    const surname = student?.name?.split("_")[1] || "";
    const description = student?.description || "";
    const interests = (student?.interestScopes || []).map(
        (scope) => t(professionScopes[scope].label)
    );
    const age = student?.birthday
        ? t("student_profile_info_age", {years: getAgeFromBirthday(student?.birthday)})
        : "";
    const city = student?.city || "";
    const dispatch = useDispatch();
    const role = useSelector(selectRole);

    const onEditClick = () => {
        dispatch(
            openDialog({
                Content: EditStudentInfo,
                title: t("student_editInfo_title"),
                closable: true,
            })
        );
    };

    // const onEmailClick = () => {
    //     if (role === "student") window.location.href = `mailto:${student.email}`;
    //     if (role === "company")
    //         dispatch(openDialog({
    //             Content: MessageToFollowers,
    //             title: "Invia un messaggio",
    //             props: {
    //                 emails: [student.email]
    //             },
    //             closable: true
    //         }))
    // };
    return (
        <div className="card studentInfo h-100">
            <div className="buttonAbsolute">
                {role === "student" && (
                    <ButtonCircle onClick={() => onEditClick()} negative={true}>
                        <EditIcon/>
                    </ButtonCircle>
                )}
            </div>
            <div
                className="avatar"
                style={{
                    backgroundImage: student?.photoUrl ? `url(${student?.photoUrl})` : `url(${profileImagePlaceholder})`,
                    alignSelf: "center",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "140px",
                    height: "140px",
                    borderRadius: "50%",
                    backgroundColor: "#21023b",
                }}
            />
            <h2>
                {name} {surname}
            </h2>
            <p className="ageCity">
                {age}
                {city && ", " + city}
            </p>
            <p className="desc">{description}</p>
            <div className="studentInfo__interests">
                {interests.map((i) => (
                    <div key={i} className="chip">
                        {i}
                    </div>
                ))}
            </div>
            {/* <div className="icon-list">
                    {download &&
                        <PDFDownloadLink document={<FollowerPDF follower={follower}/>} fileName={`${student?.name}.pdf`}>
                            {({ blob, url, loading, error }) => (loading ? 'Loading document...' :
                                <IconButton className="icon" onClick={() => onDownloadPDF()}>
                                    <GetAppIcon />
                                </IconButton>
                            )}
                        </PDFDownloadLink>
                        // <PDFViewer>
                        //     <FollowerPDF follower={follower} />
                        // </PDFViewer>
                    }
                    <IconButton className="icon" onClick={() => onEmailClick()}>
                        <MailOutlineIcon />
                    </IconButton>
                    {website &&
                        <IconButton
                            className="icon"
                            onClick={() => onWebsiteClick()}
                        >
                            <LinkIcon />
                        </IconButton>
                    }
                </div> */}
        </div>
    );
};

export default StudentInfo;
